import { ProjectId, Team, User } from 'api/models';
import { Project } from 'api/project';
import {
  useInAndNotInProjectUsers,
  useGetAssignableTeamsForProject,
} from 'hooks/use-assignee-options';

interface Props {
  project: Project;
}
interface Result {
  placeholders: Team[];
  users: {
    inProjectUsers: User[];
    notInProjectUsers: User[];
  };
}
export const useUsersForProject = ({ project }: Props): Result => {
  const projectPlaceholders = useGetAssignableTeamsForProject({
    projectId: ProjectId(project.projectId),
    onlyProjectSpecificPlaceholder: true,
  });
  // const projectPlaceholders = useMemo(() => {
  //   const placeholders =
  //     assigneeField?.metaData.projectPlaceholders?.[project.projectId] ?? [];

  //   if (isRestrictedPartnerUser) {
  //     return placeholders.filter(
  //       (placeholder) =>
  //         getResponsibleCompany(placeholder)?.companyId === loggedUserCompanyId,
  //     );
  //   }

  //   return placeholders;
  // }, [
  //   assigneeField?.metaData.projectPlaceholders,
  //   getResponsibleCompany,
  //   isRestrictedPartnerUser,
  //   loggedUserCompanyId,
  //   project.projectId,
  // ]);
  const users = useInAndNotInProjectUsers({
    projectId: ProjectId(project.projectId),
  });

  return {
    placeholders: projectPlaceholders,
    users,
  };
};
